module.exports = __webpack_public_path__ + "assets/img/32_638.c5a89037.jpg";